module.exports = __webpack_public_path__ + "img/google-colored.67caed41.png";